import { clearCache } from "../../utils/cache/cache";
import { logger } from "../../utils/logger";
import { logout } from "../slices/authSlice";

import type { Dispatch } from "@reduxjs/toolkit";

/**
 * Глобальная функция для полного выхода из системы
 */
export const performLogout = (dispatch: Dispatch): void => {
  dispatch(logout());
};

/**
 * ПРОСТОЕ РЕШЕНИЕ: очистка данных при смене пользователя
 * Сохраняет токены, очищает ВСЕ виды кэша и перезагружает страницу
 */
export const clearUserDataOnLogin = (): void => {
  logger.info("[logout] Starting comprehensive user data clearing...");

  try {
    // Сохраняем токены нового пользователя ПЕРЕД очисткой
    const token = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    // Preserve cookie consent to avoid re-showing banner after relogin
    const consent = localStorage.getItem("lingoshade_consent");

    logger.debug("[logout] Preserving tokens", {
      hasToken: !!token,
      hasRefreshToken: !!refreshToken,
    });
    logger.debug("[logout] Preserving cookie consent", {
      hasConsent: !!consent,
    });

    // АГРЕССИВНАЯ ОЧИСТКА ВСЕХ ВИДОВ КЭША

    // 0. Очищаем КАСТОМНЫЙ КЭШ приложения (КРИТИЧНО!)
    logger.debug("[logout] Clearing custom app cache");
    clearCache();

    // 1. Очищаем localStorage полностью
    localStorage.clear();

    // 2. Очищаем sessionStorage
    sessionStorage.clear();

    // 3. Очищаем IndexedDB (если используется для кэширования)
    if ("indexedDB" in window) {
      try {
        indexedDB.databases().then((databases) => {
          databases.forEach((db) => {
            if (db.name) {
              logger.debug("[logout] Clearing IndexedDB", { dbName: db.name });
              indexedDB.deleteDatabase(db.name);
            }
          });
        });
      } catch (e) {
        logger.warn("[logout] IndexedDB clearing failed (non-critical)", e);
      }
    }

    // 4. Очищаем browser cache (standard HTTP cache)
    // Note: Service Worker removed from project, using standard browser caching

    // 5. Восстанавливаем токены нового пользователя и согласие на cookies
    if (token) {
      localStorage.setItem("token", token);
      logger.info("[logout] Token restored");
    }
    if (refreshToken) {
      localStorage.setItem("refreshToken", refreshToken);
      logger.info("[logout] Refresh token restored");
    }
    if (consent) {
      localStorage.setItem("lingoshade_consent", consent);
      logger.info("[logout] Cookie consent preserved");
    }

    logger.info(
      "[logout] All caches cleared, tokens preserved, reloading page",
    );

    // 6. Принудительная перезагрузка БЕЗ кэша
    window.location.reload();
  } catch (err) {
    logger.error("[logout] Error clearing user data", err);
    // Fallback: принудительная перезагрузка
    window.location.reload();
  }
};
